import * as React from 'react';

function SvgChevronsRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 9 16" width="1em" {...props}>
      <path
        d="M8.22 8.694l-6.442 6.69a.822.822 0 01-1.163.023l-.022-.022a.887.887 0 010-1.231L6.519 8 .593 1.846a.886.886 0 010-1.23.821.821 0 011.163-.024l.022.022L8.22 7.306a1 1 0 010 1.388z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgChevronsRight;
